"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import OpenGraphPreview from "./OpenGraphPreview";
import CompoundCard, { toCompoundResponse } from "./compound/CompoundCard";
import type { CompoundResponse } from "./compound/types";
import { fetchLinkPreview } from "@/services/api/link-preview-api";
interface CompoundPreviewProps {
  readonly href: string;
}
type PreviewState = {
  readonly type: "loading";
} | {
  readonly type: "success";
  readonly data: CompoundResponse;
} | {
  readonly type: "error";
  readonly error: Error;
};
export default function CompoundPreview(t0) {
  const $ = _c(9);
  const {
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "loading"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== href) {
    t2 = () => {
      let active = true;
      setState({
        type: "loading"
      });
      fetchLinkPreview(href).then(response => {
        if (!active) {
          return;
        }
        const compound = toCompoundResponse(response);
        if (compound) {
          setState({
            type: "success",
            data: compound
          });
          return;
        }
        setState({
          type: "error",
          error: new Error("Compound preview data unavailable")
        });
      }).catch(error => {
        if (active) {
          setState({
            type: "error",
            error: error instanceof Error ? error : new Error("Failed to load Compound preview")
          });
        }
      });
      return () => {
        active = false;
      };
    };
    t3 = [href];
    $[1] = href;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (state.type === "error") {
    throw state.error;
  }
  if (state.type === "success") {
    let t4;
    if ($[4] !== href || $[5] !== state.data) {
      t4 = <CompoundCard href={href} response={state.data} />;
      $[4] = href;
      $[5] = state.data;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== href) {
    t4 = <OpenGraphPreview href={href} preview={undefined} />;
    $[7] = href;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}